import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { ConnectedKnowledgeHubBulkUpdateCategoriesProps } from '../knowledge-hub-bulk-update-categories/index.tsx';
import type KnowledgeHubBulkUpdateCategories from '../knowledge-hub-bulk-update-categories/index.tsx';

const LazyBulkUpdateCategories = lazyAfterPaint<typeof KnowledgeHubBulkUpdateCategories>(
	() =>
		import(
			/* webpackChunkName: "knowledge-hub-bulk-update-categories" */ '../knowledge-hub-bulk-update-categories'
		),
);

export const AsyncBulkUpdateCategories = (
	props: ConnectedKnowledgeHubBulkUpdateCategoriesProps,
) => (
	<ErrorBoundary
		id="bulk-update-categories"
		packageName="@atlassian/jira-servicedesk-knowledge-hub"
	>
		<Placeholder name="knowledge-hub-bulk-update-categories" fallback={null}>
			<LazyBulkUpdateCategories {...props} />
		</Placeholder>
	</ErrorBoundary>
);
